import type { FaireProductEntity } from "../../entity_types/product";

export const p_gwt66y6cr8: FaireProductEntity = {
  token: "p_gwt66y6cr8",
  type: "product",
  name: "Rotini Spirals A5 Dot Grid Notebook",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/87f018ba7aec1e743623c50d147abd0f4dbc6d50fc1b55509721f66dedc3c099.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/73bcfee091e4c472b552a4a7c8f7dfabbbc4df644d1816428faf7e9f15d142f2.jpeg",
    "https://cdn.faire.com/fastly/48fb445e7973bd5ac3c33eba0d4a99fc40c59a8adce65684c297031730fbdafc.jpeg",
    "https://cdn.faire.com/fastly/28dae17bda61a9d396b8fb8e01b1cba5def46bbf09ae4330d5759cdcfb3ea84f.jpeg",
    "https://cdn.faire.com/fastly/abb44f59a8ed0b0903e132e7b014db9313eb688f4ebf97fdf3aad9b6338e3073.jpeg",
    "https://cdn.faire.com/fastly/96c079861c888474fe1eeaf51b8f626b56e03ab41fe3fcd60762e9951065bfc3.jpeg"
  ],
  priceDollars: 11,
  description: "Inspired by the beauty of pasta shapes, our Rotini Spirals notebook is perfect for cooking notes, recipe development, or keeping track of your daily to-dos.\n\n- A5 size (~5.83\" x 8.27\")\n- Textured canvas cover\n- 192 pages (96 sheets)\n- Accordion pocket for loose papers inside the rear cover\n- Metal double-loop binding\n- Subtle blue dot grid\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:59.004Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
